module.exports = __webpack_public_path__ + "img/PL08233.ccd32c93.png";